import { Ref, watch } from "vue";
import { Reference } from "./misc";
import { updateChildren } from "../utils";
import masonry from "data-masonry";

interface ItemsProps {
  rootEl: HTMLElement;
  buttonEl: HTMLElement;
  references: Ref<Reference[]>;
  limit: Ref<number>;
}

export const Items = (props: ItemsProps) => {
  masonry();

  watch(
    [props.references, props.limit],
    ([references, limit]) => {
      const items = [];

      for (let i = 0; i < limit; i++) {
        const reference = references[i];
        if (reference) {
          items.push(renderReference(reference));
        }
      }

      updateChildren(props.rootEl, items);

      if (limit >= references.length) {
        props.buttonEl.style.display = "none";
      } else {
        props.buttonEl.style.display = "";
      }

      const reloadMasonry = new Event("reload:masonry", {
        bubbles: true,
      });

      dispatchEvent(reloadMasonry);
    },
    { immediate: true, deep: true }
  );
};

const renderReference = (reference: Reference) => {
  const item = document.createElement("article");
  item.classList.add("reference-card");

  item.innerHTML = `
    <img src="${reference.previewImage}" alt="${reference.title}" />
    <h3>${reference.title}</h3>
    <p class="paragraph">${reference.teaser.short}</p>
    <a href="${reference.slug}" class="link link--underline"><span>Mehr erfahren</span></a>
  `;

  return item;
};
